module.exports = __webpack_public_path__ + "static/media/classic_dream.6d547717.png";